// Same-origin API: works on astralsand.com, www and preview (ingress routes /api to the backend).
export const API = "/api";
